import CaptchaDialog from './CaptchaDialog';
import './style/captcha-dialog.less';

export default CaptchaDialog;
